// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.grid-wrapper {
  flex: 1 1;
  width: 100%;
}

#myGrid {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/Components/settings/TableExample/Tabels/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;AACd","sourcesContent":[".example-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.grid-wrapper {\n  flex: 1 1 0px;\n  width: 100%;\n}\n\n#myGrid {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
